import { CheckoutSessionListModule } from '@/components/modules/CheckoutSession/List/CheckoutSessionList';
import { PAGE_AGENT_ALLOWED_ROLES } from '@/components/views/DynamicPageView/config/layoutScheme/constants/PageAgentAllowedRoles';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_USER_TYPES, APP_ROLES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_CHECKOUT_SESSION_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST,
  schemesByRoles: [
    {
      roles: [...PAGE_AGENT_ALLOWED_ROLES, APP_ROLES.AGENT, APP_ROLES.MERCHANT_GROUP],
      titleTextId: 'CHECKOUT_SESSIONS',
      widgets: [],
    },
  ],
  sections: [
    // {
    //   textId: undefined,
    //   module: (
    //     <MetricsProductExternalModule
    //       permissions={{
    //         view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
    //       }}
    //       productExternal={ProductExternal.CONSUMER_LOAN}
    //     />
    //   ),
    // },
    {
      textId: undefined,
      module: (
        <CheckoutSessionListModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
